import type { SVGProps } from 'react';
import React from 'react';

export const HelpIcon: React.FC<SVGProps<SVGSVGElement>> = ({
  ...props
}) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="transparent"
      {...props}
    >
      <path
        d="M10 16.4609C10.5393 16.4609 10.9766 16.0237 10.9766 15.4844C10.9766 14.945 10.5393 14.5078 10 14.5078C9.46066 14.5078 9.02344 14.945 9.02344 15.4844C9.02344 16.0237 9.46066 16.4609 10 16.4609Z"
        fill="currentColor"
      />
      <path
        d="M10 0.698242C4.47328 0.698242 0 5.17078 0 10.6982C0 16.225 4.47254 20.6982 10 20.6982C15.5267 20.6982 20 16.2257 20 10.6982C20 5.17152 15.5275 0.698242 10 0.698242ZM10 19.1357C5.33684 19.1357 1.5625 15.362 1.5625 10.6982C1.5625 6.03508 5.33621 2.26074 10 2.26074C14.6632 2.26074 18.4375 6.03445 18.4375 10.6982C18.4375 15.3614 14.6638 19.1357 10 19.1357Z"
        fill="currentColor"
      />
      <path
        d="M10 5.7168C8.27688 5.7168 6.875 7.11867 6.875 8.8418C6.875 9.27328 7.22477 9.62305 7.65625 9.62305C8.08773 9.62305 8.4375 9.27328 8.4375 8.8418C8.4375 7.98023 9.13844 7.2793 10 7.2793C10.8616 7.2793 11.5625 7.98023 11.5625 8.8418C11.5625 9.70336 10.8616 10.4043 10 10.4043C9.56852 10.4043 9.21875 10.7541 9.21875 11.1855V13.1387C9.21875 13.5702 9.56852 13.9199 10 13.9199C10.4315 13.9199 10.7812 13.5702 10.7812 13.1387V11.8679C12.1276 11.5202 13.125 10.2953 13.125 8.8418C13.125 7.11867 11.7231 5.7168 10 5.7168Z"
        fill="currentColor"
      />
    </svg>
  );
};